// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__TkLzl","ButtonSuccess":"Modal_ButtonSuccess__85Du9"};